<template>
    <div class="group-news app">
        <div class="header-empty"></div>
        <div class="main-content">
            <breadItem :title1="breadTitle1" :title2="breadTitle2" :link1="breadLink1" :link2="breadLink2"></breadItem>
            <div class="editor">
                <div class="title-box tc">
                    <div class="title fs18 fwb color-blank">{{data.introduce_title}}</div>
                </div>
                <div class="quill-editor">
                    <div class="ql-container ql-snow">
                        <div class="ql-editor contents" v-html="data.introduce_content"></div>
                    </div>
                </div>
            </div>
            <nav-top></nav-top>
        </div>
    </div>
</template>

<script>
import navTop from '@/components/top'
import breadItem from '@/components/breadItem'
export default {
    components: {
        navTop,
        breadItem
    },
    data() {
        return {
            data:'',
            breadTitle1:'关于我们',
            breadTitle2:'集团介绍',
            breadLink1:'/aboutUs/0.html',
            breadLink2:''
        };
    },
    computed: {

    },
    created() {
        this.$axios.post(this.api.about.intro,{},res =>{
            this.data=res.data;
        });
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        
    },
    
};
</script>

<style scoped>
    .title-box{padding:40px 0;}
    .title-box .title{line-height:25px;}
    .title-box .time{line-height:20px;margin:20px 0 10px 0;}
    .title-box .name{line-height:20px;}
    .contents{width:1120px;margin:0 auto 20px;word-break:break-all;}
    .contents img{max-width:100%;}
</style>



// WEBPACK FOOTER //
// src/view/aboutUs/index.vue